<template>
  <!-- eslint-disable-next-line vue/no-mutating-props -->
  <a-drawer v-model:visible="props.visible"
            width='50%'
            :title="$t('orderManagement.Express.logisticsInformation')"
            placement="right"
            :destroy-on-close="true"
            @close="closeClick">
    <div class="drawer-content">
      <div class="receive-box">
        <img :src="receive"
             class="icon" />
        <div class="receive-address">{{ receiveAddress }}</div>
      </div>
      <a-divider type="vertical"
                 style="border-color: #f1f1f1;height: 30px;margin-left: 15px;" />
      <a-steps :initial="rowData.length"
               :current="rowData.length"
               direction="vertical">
        <a-step v-for="log in rowData"
                :title="log.memo">
          <template #icon>
            <img v-if="log.status"
                 :src="logistics"
                 class="icon" />
            <div v-else
                 class=" flex">
              <div class="icon-box"></div>
            </div>
          </template>
          <template #description>
            <div class="subTitle-box">{{ log.time }}</div>
          </template>
        </a-step>
      </a-steps>
    </div>
  </a-drawer>
</template>
<script setup lang="ts">
import logistics from '../../assets/ic_logistics.png'
import receive from '../../assets/ic_receive.png'
const props = defineProps<{
  visible: boolean
  receiveAddress: string
  rowData: any
}>()
const emit = defineEmits(['visibleChange'])
const closeClick = () => {
  emit('visibleChange', false)
}

</script>
<style scoped lang="less">
.drawer-content {
  padding: 0;
  padding-left: 130px;
  font-size: 14px;
  font-family: 'Microsoft YaHei';

  .ant-steps-item {
    height: 60px;

    :deep(.ant-steps-item-title) {
      font-size: 14px;
      font-family: 'Microsoft YaHei';
    }

    :deep(.ant-steps-item-tail::after) {
      position: absolute;
      top: 16px;
    }

  }

  .receive-box {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 4px;

    .receive-address {
      color: #999999;
      margin-left: 20px;
    }
  }

  .icon {
    height: 24px;
    width: 24px;
  }

  .icon-box {
    width: 10px;
    height: 10px;
    background: #CCCCCC;
    border-radius: 50%;
  }

  .flex {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .subTitle-box {
    width: 100px;
    position: absolute;
    left: -100px;
    top: 0;
  }
}
</style>